
import { toast } from 'react-toastify';

export const toaster = {
    success: (message: string) => {
        if (!message) {
            return;
        }
        return toast.success(message, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light'
        })
    },
    error: (message: any) => {
        if (!message) {
            return;
        }
        return toast.error(message, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light'
        })
    },
}